module.exports = __webpack_public_path__ + "static/img/scenarios2_pho.0fa5e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scenarios2_pho.png
// module id = U3x4
// module chunks = 0